import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import CommonButton from '../../Components/CommonButton';
import { organization_domain, toggle_blacklist, toggle_popup } from '../../services';
import SceenLoader from '../../Components/ScreenLoader';
import { useNavigate } from 'react-router-dom';
import ButtonLoader from '../../Components/ButtonLoader';
import AddDomainModal from './AddDomainModal';


function WhiteListDomainModal(props) {
    const [organizationName, setOrganization] = useState([]);
    const [selectedDomains, setSelectedDomains] = useState({});
    const [screenLoader, setScreenLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showAddDomainModal, setShowAddDomainModal] = useState(false);

    const navigate = useNavigate();
    const organization_name = async () => {
        setScreenLoader(true)
        const response = await organization_domain();
        setOrganization(response?.statusCode?.response_data?.data);
        setScreenLoader(false)
    };

    useEffect(() => {
        organization_name();
    }, []);

    const handleCheckboxChange = (id, type, isChecked) => {
        setSelectedDomains(prev => ({
            ...prev,
            [id]: { id, type, "blacklist_status": !isChecked }
        }));
    };

    const toggleBlacklist = async () => {
        const payload = {
            'items': Object.values(selectedDomains),
        };
        setLoading(true)
        const response = await toggle_blacklist(payload);
        if (response) {
            props.onHide();
            navigate(0)
        }
        setLoading(false);
    };

    const closePopup = async () => {
        const response = await toggle_popup();
        const popupClosed = response?.statusCode?.response_data?.data?.is_popup_closed
        if (popupClosed) {
            localStorage.setItem('is_popup_closed', 'true');
        }
        props.onHide();
    }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='cstm_modal'
        >
            <Modal.Header closeButton onClick={closePopup} />
            <Modal.Body>
                <div className='white_list_box mb-3'>
                    <div className='px-4 d-flex justify-content-between align-items-center mb-4'>
                        <h2 className='font_24 font_700 color_white mb-0'>Live Domain Whitelist</h2>
                        <CommonButton 
                            text="Add Domain" 
                            onClick={() => setShowAddDomainModal(true)} 
                            className='btn_style'
                        />
                    </div>
                    {screenLoader ? <SceenLoader /> :
                        <>
                            <ul>
                                {organizationName.length === 0 ? (
                                    <span className='mt-5 font_14 color_white d-flex justify-content-center my-4'> No Similar Domains Found</span>
                                ) : (
                                    organizationName.map((item) => (
                                        <li className='white_list_data' key={item?.id}>
                                            <input
                                                type='checkbox'
                                                defaultChecked={item?.is_blacklisted === false}
                                                onChange={(e) =>
                                                    handleCheckboxChange(item?.id, 'domain', e.target.checked)
                                                }
                                            />
                                            {item?.domain_name}
                                        </li>
                                    ))
                                )}
                            </ul>
                            <div className='px-4'>
                                <CommonButton text={loading ? <ButtonLoader /> : 'Submit'} onClick={toggleBlacklist} className='btn_style' />
                            </div>
                        </>
                    }
                </div>
            </Modal.Body>
            {showAddDomainModal && (
                <AddDomainModal
                    show={showAddDomainModal}
                    onHide={() => setShowAddDomainModal(false)}
                    onSuccess={() => {
                        setShowAddDomainModal(false);
                        organization_name();
                    }}
                />
            )}
        </Modal>
    );
}

export default WhiteListDomainModal;
